import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cuánto tiempo toma ver resultados?',
  answer: 'La mayoría de nuestros clientes ven un aumento en llamadas y visitas dentro de los primeros 30-60 días. El SEO local toma 60-90 días para posicionamiento completo.'
}, {
  question: '¿Funciona en mi ciudad?',
  answer: 'Sí. Trabajamos con talleres en todo Estados Unidos. Nuestra estrategia de SEO local se adapta a cualquier mercado.'
}, {
  question: '¿Cuánto cuesta?',
  answer: 'Cada plan es personalizado según el tamaño de tu taller y tus metas. Agenda tu diagnóstico gratuito y te damos un presupuesto exacto.'
}, {
  question: '¿Necesito tener redes sociales?',
  answer: 'No es obligatorio, pero ayuda. Nosotros nos encargamos de crear y optimizar todo lo que necesites.'
}, {
  question: '¿Qué pasa si ya hice ads y no funcionaron?',
  answer: 'El 90% de los talleres que llegan a nosotros tuvieron malas experiencias con agencias genéricas. Nosotros nos especializamos en negocios locales de servicio automotriz.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-pure-black border-t border-white/5" data-id="element-116">
      <div className="container mx-auto px-6" data-id="element-117">
        <div className="text-center mb-16" data-id="element-118">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-black text-electric-yellow mb-4 uppercase tracking-wide" data-id="element-119">
            Preguntas Frecuentes
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scaleX: 0
        }} whileInView={{
          opacity: 1,
          scaleX: 1
        }} viewport={{
          once: true
        }} className="h-1 w-24 bg-electric-yellow mx-auto rounded-full" data-id="element-120" />
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-121">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-gray border border-white/10 rounded-lg overflow-hidden" data-id="element-122">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-123">
                <span className="text-white font-bold text-lg pr-8" data-id="element-124">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-electric-yellow shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-125" />
              </button>

              <AnimatePresence data-id="element-126">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-127">
                    <div className="px-6 pb-5 text-gray-400 leading-relaxed border-t border-white/5 pt-4" data-id="element-128">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center mt-12" data-id="element-129">
          <p className="text-gray-400 mb-4" data-id="element-130">¿Tienes otra pregunta?</p>
          <button onClick={scrollToContact} className="text-electric-yellow font-bold uppercase tracking-wider hover:text-white transition-colors underline underline-offset-4" data-id="element-131">
            Contáctanos directamente
          </button>
        </motion.div>
      </div>
    </section>;
}